import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface RoleBadgeProps {
  role: string;
  size?: 'sm' | 'md';
}

const roleColors: Record<string, { light: string; dark: string }> = {
  admin: {
    light: 'bg-red-100 text-red-800 border border-red-300',
    dark: 'bg-red-900 text-red-200 border border-red-700',
  },
  editor: {
    light: 'bg-blue-100 text-blue-800 border border-blue-300',
    dark: 'bg-blue-900 text-blue-200 border border-blue-700',
  },
  viewer: {
    light: 'bg-gray-100 text-gray-800 border border-gray-300',
    dark: 'bg-gray-700 text-gray-200 border border-gray-600',
  },
};

const defaultColors = {
  light: 'bg-gray-100 text-gray-800 border border-gray-300',
  dark: 'bg-gray-700 text-gray-200 border border-gray-600',
};

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role, size = 'sm' }) => {
  const { darkMode } = useTheme();
  const colors = roleColors[role.toLowerCase()] || defaultColors;

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-3 py-1 text-sm';

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full leading-5 ${sizeClasses} ${
        darkMode ? colors.dark : colors.light
      }`}
    >
      {role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()}
    </span>
  );
};

export default RoleBadge;
